// src/components/services/Savoir.jsx
import * as React from 'react'
import { Container, Box, Typography, Paper, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

// i18n
import { useI18n } from '../../i18n/I18nProvider'
import savoirI18n from '../../i18n/components/services/savoir.i18n'

export default function Savoir() {
  const { t, register } = useI18n()
  React.useEffect(() => { register('services', savoirI18n) }, [register])

  const cards = React.useMemo(() => ([
    {
      title: t('services.savoir.cards.security.title'),
      body:  t('services.savoir.cards.security.body'),
      cta:   { label: t('services.savoir.cards.security.cta'), to: '/envoi-securise' },
    },
    {
      title: t('services.savoir.cards.transparent.title'),
      body:  t('services.savoir.cards.transparent.body'),
      cta:   { label: t('services.savoir.cards.transparent.cta'), to: '/criteres-rachat' },
    },
  ]), [t])

  return (
    <Box sx={{ bgcolor: '#fff' }}>
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 2 } }}>
        {/* Titre */}
        <Typography
          component="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: 22, sm: 24, md: 28 },
            lineHeight: 1.2,
            mb: { xs: 2, md: 2.5 },
          }}
        >
          {t('services.savoir.title')}
        </Typography>

        {/* Intro courte */}
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: { xs: 14.5, sm: 15, md: 16 },
            lineHeight: 1.7,
            mb: { xs: 3, md: 4 },
            maxWidth: 1200,
          }}
        >
          {t('services.savoir.intro')}
        </Typography>

        {/* === 2 colonnes à partir de md === */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 2, md: 3 },
          }}
        >
          {cards.map((c) => (
            <Paper
              key={c.title}
              elevation={3}
              sx={{
                bgcolor: '#0466c8',
                color: '#fff',
                borderRadius: 3,
                p: { xs: 2.5, md: 3 },
                minHeight: 180,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography
                  component="h3"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: 16.5, sm: 17, md: 18 },
                    textDecoration: 'underline',
                    mb: 1.5,
                  }}
                >
                  {c.title}
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: 14.5, sm: 15, md: 16 },
                    lineHeight: 1.7,
                    color: 'rgba(255,255,255,0.95)',
                    mb: 2.5,
                  }}
                >
                  {c.body}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  component={RouterLink}
                  to={c.cta.to}
                  variant="contained"
                  sx={{
                    backgroundColor: '#fff',
                    color: '#0466c8',
                    fontWeight: 700,
                    textTransform: 'none',
                    borderRadius: 99,
                    px: 2.5,
                    py: 0.75,
                    boxShadow: 'none',
                    '&:hover': { backgroundColor: '#f5f5f5', boxShadow: 'none' },
                  }}
                >
                  {c.cta.label}
                </Button>
              </Box>
            </Paper>
          ))}
        </Box>

        <Paper
          elevation={0}
          sx={{
            mt: { xs: 2, md: 3 },
            px: { xs: 2.5, md: 3.5 },
            py: { xs: 2.5, md: 3 },
            borderRadius: 3,
            border: '1px solid #cfe1f5',
            bgcolor: '#eef6ff',
            display: { md: 'flex' },
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography component="h3" sx={{ color: '#0466c8', fontWeight: 800, fontSize: { xs: 18, md: 20 } }}>
              {t('services.savoir.collect.title')}
            </Typography>
            <Typography sx={{ mt: 0.75, color: '#465d73', lineHeight: 1.7, fontSize: { xs: 14.5, md: 16 } }}>
              {t('services.savoir.collect.body')}
            </Typography>
          </Box>
          <Button
            component="a"
            href="https://collect.123back.eu"
            variant="contained"
            sx={{
              mt: { xs: 2, md: 0 },
              flexShrink: 0,
              bgcolor: '#0466c8',
              textTransform: 'none',
              fontWeight: 800,
              borderRadius: 99,
              px: 2.5,
              boxShadow: 'none',
              '&:hover': { bgcolor: '#004890', boxShadow: 'none' },
            }}
          >
            {t('services.savoir.collect.cta')}
          </Button>
        </Paper>
      </Container>
    </Box>
  )
}
